module.exports = __webpack_public_path__ + "static/NBInternationalPro-Bold-0de105067155ff2f4fd0dbb03d74a128.woff";